import { render, staticRenderFns } from "./myincome copy.vue?vue&type=template&id=6fbe9103&scoped=true"
import script from "./myincome copy.vue?vue&type=script&lang=js"
export * from "./myincome copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbe9103",
  null
  
)

export default component.exports